import {
	setHours,
	setMinutes,
	setSeconds,
	differenceInSeconds,
	addDays,
} from 'date-fns';

export default class DeliveryNotice extends HTMLElement {
	constructor() {
		super();
		this.el = this;
		this.secondInterval = null;
		this.parsedCutoffTime = new Date();
		this.deliveryCutoffTime = this.getAttribute('delivery-cutoff-time');
	}

	connectedCallback() {
		this.initCountDown();
	}

	initCountDown() {
		if (this.deliveryCutoffTime) {
			const [hours, minutes] = this.deliveryCutoffTime.split(':');

			this.parsedCutoffTime = setHours(
				this.parsedCutoffTime,
				parseInt(hours, 10),
			);
			this.parsedCutoffTime = setMinutes(
				this.parsedCutoffTime,
				parseInt(minutes, 10),
			);
			this.parsedCutoffTime = setSeconds(this.parsedCutoffTime, 0);

			// je stock l'intervalle de temps
			if (this.deliveryCutoffTime) {
				this.destroy();
				this.secondInterval = setInterval(() => {
					// Arrêter l'intervalle de temps précédent s'il existe
					this.onTick();
				}, 10);
			}
		}
	}

	destroy() {
		// deelte l'intervalle de temps précédent
		if (this.secondInterval) {
			clearInterval(this.secondInterval);
			this.secondInterval = null;
		}
	}

	onTick() {
		if (this.el) {
			let totalSecondsLeft = differenceInSeconds(
				this.parsedCutoffTime,
				new Date(),
			);
			if (totalSecondsLeft < 0) {
				this.parsedCutoffTime = addDays(this.parsedCutoffTime, 1);
				totalSecondsLeft = differenceInSeconds(
					this.parsedCutoffTime,
					new Date(),
				);
			}

			const hoursLeft = Math.floor(totalSecondsLeft / 3600);
			totalSecondsLeft %= 3600;

			const minutesLeft = Math.floor(totalSecondsLeft / 60);
			totalSecondsLeft %= 60;

			const formattedTime = `
            ${hoursLeft} ${window.timeString.hours}
            ${minutesLeft} ${window.timeString.minutes}
            ${totalSecondsLeft} ${window.timeString.seconds}
        `.replace('\n', '');

			// Effacer le contenu précédent de this.el.textContent
			this.el.textContent = '';

			// Mettre à jour this.el.textContent avec la nouvelle valeur
			this.el.textContent = formattedTime;

			this.updateTimeRemaining(formattedTime);
		}
	}

	updateTimeRemaining(formattedTime) {
		if (this.el) {
			this.el.textContent = formattedTime;
		}
	}
}
